module.exports = __webpack_public_path__ + "img/StaticNormal.e21a156e.svg";